import React from 'react'

const LayoutWrapper = ({ children, extraClass }) => {
    return (
        <div data-wrappername="LayoutWrapper" style={{ boxShadow: "0px 2px 48px #0000000A" }} className={`p-4 bg-white rounded flex flex-col min-h-[calc(100vh-120px)] ${extraClass || ''}`}>
            {children}
        </div>
    )
}

export default LayoutWrapper